import { useContext } from "react";

import { ContactContext } from "@/context/ContactProvider.context";

import type { ContactContextType } from "@/context/ContactProvider.context";

const useContactContext = (): ContactContextType => useContext(ContactContext);

export default useContactContext;
